// aifab - Topbar
import { NAV } from '../../constants/nav';
import { TOURS } from '../tour/TourGuide';

// Sub-pages reachable without a sidebar entry (e.g. wizards opened from a
// list page) aren't in NAV, so they'd otherwise fall back to their raw
// page key ("create-run") as the title.
const SUBPAGE_TITLES = {
  'create-run': 'New Run',
};

export function Topbar({ page, version, onTour }) {
  const nav      = NAV.find(n => n.key === page);
  const hasTour  = !!(TOURS[page]?.length);
  return (
    <div className="topbar">
      <div className="topbar-left">
        <span className="topbar-title">{nav?.label ?? SUBPAGE_TITLES[page] ?? page}</span>
      </div>
      <div className="topbar-right" style={{ display:'flex', alignItems:'center', gap:10 }}>
        {hasTour && (
          <button onClick={onTour} style={{
            display:'flex', alignItems:'center', gap:6,
            padding:'5px 12px', borderRadius:6,
            border:'1px solid rgba(232,71,10,.25)',
            background:'rgba(232,71,10,.06)',
            color:'#E8470A', fontSize:11.5, fontWeight:600,
            cursor:'pointer', transition:'all .15s',
            letterSpacing:'.01em',
          }}
          onMouseEnter={e => { e.currentTarget.style.background='rgba(232,71,10,.1)'; e.currentTarget.style.borderColor='rgba(232,71,10,.4)'; }}
          onMouseLeave={e => { e.currentTarget.style.background='rgba(232,71,10,.06)'; e.currentTarget.style.borderColor='rgba(232,71,10,.25)'; }}
          title="Take a guided tour of this page"
          >
            <span style={{ fontSize:13 }}>◎</span> Take Tour
          </button>
        )}
        <span className="badge b-gray" style={{ fontFamily:'var(--f-mono)', fontSize:10 }}>
          v{version || '0.7.7'}
        </span>
      </div>
    </div>
  );
}
